import { fromJS, List, OrderedMap } from 'immutable';
import InventoryRecordConstants from '../constants/InventoryRecordConstants';
import InventoryRecordStore from '../stores/InventoryRecordStore';
import InventoryRecord from '../models/InventoryRecord';
import SimilarProductsCategory from '../models/SimilarProductsCategory';
import { navigateAction } from 'fluxible-router';
import BanquetRouteManager from '../lib/BanquetRouteManager';

const InventoryRecordActions = {
  list(context, payload) {
    // optionally provide 'forceRetry' in payload to allow subsequent identical requests
    payload.pagination = payload.pagination || InventoryRecordStore.defaultPagination;
    payload.sorter = payload.sorter || InventoryRecordStore.defaultSorter;
    payload.filters = payload.filters || [];

    let requestPayload = {
      filters: payload.filters,
      pagination: payload.pagination,
      sort: [payload.sorter]
    };

    if(context.getCurrentStore()) {
      requestPayload.filters.push({type: 'store_id', value: context.getCurrentStore().id});
    }

    context.dispatch(InventoryRecordConstants.LIST_INVENTORY_RECORDS_START, payload);
    // Remove optional args
    delete payload.forceRetry;

    return context
      .delectoryApi
      .inventoryRecords
      .list(requestPayload)
      .then(responsePayload => {
        let inventoryRecords = responsePayload.inventory_records.reduce((map, inventoryRecord) => {
          return map.set(inventoryRecord.id, new InventoryRecord(inventoryRecord));
        }, new OrderedMap());
        payload.pagination.totalResults = responsePayload.total_results;
        context.dispatch(InventoryRecordConstants.LIST_INVENTORY_RECORDS_SUCCESS, {
          entities: inventoryRecords,
          filters: payload.filters,
          pagination: payload.pagination,
          sorter: payload.sorter,
          suggestedFilters: responsePayload.suggested_filters
        });
      })
      .catch(err => {
        context.dispatch(InventoryRecordConstants.LIST_INVENTORY_RECORDS_FAILURE, {error: err});
      });
  },

  fetch(context, payload) {
    context.dispatch(InventoryRecordConstants.FETCH_INVENTORY_RECORD_START, payload.id);
    return context
      .delectoryApi
      .inventoryRecords
      .inventoryRecord({id: payload.id})
      .then(responsePayload => {
        let inventoryRecord = new InventoryRecord(responsePayload.inventory_record);
        context.dispatch(InventoryRecordConstants.FETCH_INVENTORY_RECORD_SUCCESS, inventoryRecord);
        context.dispatch(InventoryRecordConstants.SET_CURRENT_INVENTORY_RECORD, inventoryRecord.id);
        context.trackEvent('Product Clicked', {
          product_id: inventoryRecord.id,
          name: inventoryRecord.name,
          brand: inventoryRecord.brand,
          price: inventoryRecord.current_price
        });
      })
      .catch(err => {
        context.dispatch(InventoryRecordConstants.FETCH_INVENTORY_RECORD_FAILURE, {entityId: payload.id, error: err});
        if(err.code === 2000) {
          err.statusCode = 404;
        }
        throw err;
      });
  },

  fetchBySupplierSku(context, payload) {
    context.dispatch(InventoryRecordConstants.FETCH_INVENTORY_RECORD_START, payload.id);
    return context
      .delectoryApi
      .inventoryRecords
      .inventoryRecordBySupplierSku({store_id: payload.store_id, external_sku: payload.supplier_sku})
      .then(responsePayload => {
        let inventoryRecord = new InventoryRecord(responsePayload.inventory_record);
        context.dispatch(InventoryRecordConstants.FETCH_INVENTORY_RECORD_SUCCESS, inventoryRecord);
        context.dispatch(InventoryRecordConstants.SET_CURRENT_INVENTORY_RECORD, inventoryRecord.id);
        let banquetRouteManager = new BanquetRouteManager({loadPathsOnly: true});
        let url = '/' + payload.store_slug + banquetRouteManager.buildURLForRoute('inventoryRecord', {id: inventoryRecord.id, slug: inventoryRecord.slug});

        context.trackEvent('Product Clicked', {
          product_id: inventoryRecord.id,
          name: inventoryRecord.name,
          brand: inventoryRecord.brand,
          price: inventoryRecord.current_price
        });
        return context.executeAction(navigateAction, {url: url});;
      })
      .catch(err => {
        context.dispatch(InventoryRecordConstants.FETCH_INVENTORY_RECORD_FAILURE, {entityId: payload.id, error: err});
        if(err.code === 2000) {
          err.statusCode = 404;
        }
        throw err;
      });
  },

  fetchSimilar(context, payload) {
    let entityId = payload.id;
    context.dispatch(InventoryRecordConstants.FETCH_SIMILAR_INVENTORY_RECORDS_START, payload.id);
    return context
      .delectoryApi
      .inventoryRecords
      .similarProducts({id: entityId})
      .then(responsePayload => {
        let categories = responsePayload.categories.reduce((list, category) => {
          category.inventory_record_id = payload.id;
          return list.push(new SimilarProductsCategory(category));
        }, new List());
        context.dispatch(InventoryRecordConstants.FETCH_SIMILAR_INVENTORY_RECORDS_SUCCESS, {entityId, categories});
      })
      .catch(err => {
        context.dispatch(InventoryRecordConstants.FETCH_SIMILAR_INVENTORY_RECORDS_FAILURE, {entityId, error: err});
      });
  },

  fetchStats(context, payload) {
    context.dispatch(InventoryRecordConstants.FETCH_INVENTORY_RECORD_STATS_START, {});
    return context
      .delectoryApi
      .inventoryRecords
      .stats(payload)
      .then(responsePayload => {
        let stats = responsePayload.inventory_record_stats;
        context.dispatch(InventoryRecordConstants.FETCH_INVENTORY_RECORD_STATS_SUCCESS, {storeId: payload.store_id, stats: stats});
      })
      .catch(err => {
        context.dispatch(InventoryRecordConstants.FETCH_INVENTORY_RECORD_STATS_FAILURE, err);
      });
  }
};

export default InventoryRecordActions;



// WEBPACK FOOTER //
// banquet/actions/InventoryRecordActions.js